import { Product } from './Product';
import { ensureElement, createElement } from '../../utils/utils';
import { Component } from '../base/component';
export class ProductCart extends Product {
    constructor(container, events) {
        super(container);
        this._deleteButton = ensureElement('.basket__item-delete', container);
        this._index = ensureElement('.basket__item-index', container);
        this._deleteButton.addEventListener('click', events.onClick);
    }
    set index(value) {
        this.setText(this._index, value);
    }
}
export class Cart extends Component {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._productsList = ensureElement('.basket__list', container);
        this._totalPrice = ensureElement('.basket__price', container);
        this._orderButton = ensureElement('.button', container);
        this._orderButton.addEventListener('click', () => {
            this.events.emit('paymentForm:render');
        });
    }
    set products(products) {
        if (products.length) {
            this._productsList.replaceChildren(...products);
            this.setDisabled(this._orderButton, false);
        }
        else {
            this._productsList.replaceChildren(createElement('p', {
                textContent: 'Пусто, добавьте товар в корзину',
            }));
            this.setDisabled(this._orderButton, true);
        }
    }
    set totalPrice(total) {
        this.setText(this._totalPrice, `${total} синапсов`);
    }
}
